// Homepage JS

const ribbon = document.getElementById('ribbon');
const video = document.querySelector('.homepage-video-bg');

const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

const playRibbon = () => ribbon?.play();
const pauseRibbon = () => ribbon?.pause();

const playVideo = () => video?.play();
const pauseVideo = () => video?.pause();

const addRibbonHover = () => {
  ribbon?.addEventListener('mouseenter', pauseRibbon);
  ribbon?.addEventListener('mouseleave', playRibbon);
}

const removeRibbonHover = () => {
  ribbon?.removeEventListener('mouseenter', pauseRibbon);
  ribbon?.removeEventListener('mouseleave', playRibbon);
}

if (!prefersReducedMotion || prefersReducedMotion.matches) {
  pauseVideo()
  if (!ribbon?.getLottie()?.isLoaded) {
    ribbon?.addEventListener('ready', pauseRibbon);
  } else {
    pauseRibbon();
  }
} else {
  addRibbonHover();
}

// Ads an event listener to check for changes in the media query's value.
prefersReducedMotion.addEventListener("change", () => {
  if (prefersReducedMotion.matches) {
    pauseVideo();
    pauseRibbon();
    removeRibbonHover();
  } else {
    playVideo();
    playRibbon();
    addRibbonHover();
  }
});
